enum FileUploadResourceTypeEnum {
    catalog = "catalog",
    catalogItem = "catalogItem",
    orderItem = "orderItem",
    shipmentGroup = "shipmentGroup",
    shipment = "shipment",
    vendorResaleTaxDoc = "vendorResaleTaxDoc",
    vendorCreditCardAuthDoc = "vendorCreditCardAuthDoc",
    catalogItemFileAttachmentOne = "catalogItemFileAttachmentOne",
    catalogItemFileAttachmentTwo = "catalogItemFileAttachmentTwo",
    catalogItemFileAttachmentThree = "catalogItemFileAttachmentThree",
    catalogItemFileAttachmentFour = "catalogItemFileAttachmentFour",
    logo = "logo",
    bulkImages = "bulkImages",
    brandedLoginLogo = "brandedLoginLogo",
    docLogo = "docLogo",
    /** Images placed in supplier email templates (public bucket; mail clients must fetch them). */
    emailTemplateImage = "emailTemplateImage",
    catalogItemTemplateCsv = "catalogItemTemplateCsv",
    childItemTemplateCsv = "childItemTemplateCsv",
    priceListCsv = "priceListCsv",
    vendorCsv = "vendorCsv",
    bulkOrdersCsv = "bulkOrdersCsv",
    purchaseOrderItem = "purchaseOrderItem",
    catalogItemCategoriesCsv = "catalogItemCategoriesCsv",
    vendorStateLicense = "vendorStateLicense",
    public = "public",
    priceBandsCsv = "priceBandsCsv",
    bulkItemOptionsCsv = "bulkItemOptionsCsv",
    catalogAttributesCsv = "catalogAttributesCsv",
    bulkKitBuilderCsv = "bulkKitBuilderCsv",
    priceBandsBulkApplyCsv = "priceBandsBulkApplyCsv",
    itemOptionsAssignCsv = "itemOptionsAssignCsv",
    // Delivery app types (Enroute)
    deliverySignature = "deliverySignature",
    deliveryPhoto = "deliveryPhoto",
    bulkNotesCsv = "bulkNotesCsv",
    bulkSerialsCsv = "bulkSerialsCsv",
    vendorSourceCatalogItemsCsv = "vendorSourceCatalogItemsCsv",
    catalogItemImagesUrlCsv = "catalogItemImagesUrlCsv",
}

export default FileUploadResourceTypeEnum;
